<script lang="ts">
  import { signup } from '$lib/utils/api';
  import { isValidEmail } from '$lib/utils/helpers';
  import Loader from './Loader.svelte';
  
  export let birthYear: number;
  export let birthMonth: number;
  
  let email = '';
  let isSubmitting = false;
  let showError = false;
  let showSuccess = false;
  
  async function handleSignup() {
    if (!isValidEmail(email)) {
      showError = true;
      return;
    }
    
    showError = false;
    isSubmitting = true;
    
    const result = await signup({
      email,
      birthYear,
      birthMonth
    });
    
    isSubmitting = false;
    
    if (result.success) {
      showSuccess = true;
    } else {
      showError = true;
    }
  }
</script>

<div id="signup-container">
  <div id="signup-info">
    <h2>Continue playing</h2>
    <p>Get a notification when your ranking changes.</p>
  </div>

  {#if !showSuccess}
    <form id="signup-area" on:submit|preventDefault={handleSignup}>
      <div>
        <input
          type="email"
          bind:value={email}
          placeholder="Email"
          disabled={isSubmitting}
        />
      </div>

      {#if isSubmitting}
        <Loader text="Signing up..." />
      {:else}
        <div id="signup-button-container">
          <button type="submit" class="button big">Sign up</button>
        </div>
      {/if}
    </form>
    
    {#if showError}
      <div id="signup-error" class="error">
        <i class="bi-x-circle-fill"></i> Sign up failed. Please check the email address.
      </div>
    {/if}
  {:else}
    <div id="signup-success">
      <i class="bi-check-circle-fill"></i> Welcome! Please check your email and click on the link to confirm your address.
    </div>
  {/if}
</div>

<style>
  #signup-container {
    margin: 3em 0 2em 0;
  }

  #signup-info h2 {
    margin-bottom: 0.5em;
  }

  #signup-area {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  #signup-area div {
    margin: 0.5em 0.25em;
  }

  #signup-area input {
    width: 15em;
  }

  #signup-button-container {
    width: 10em;
  }

  .error {
    color: #ef6480;
    margin: 1em 0 0 0;
  }

  #signup-success {
    color: #00aa00;
  }
</style>
